import { render, staticRenderFns } from "./InquiryTable.vue?vue&type=template&id=153ceea4&scoped=true"
import script from "./InquiryTable.vue?vue&type=script&lang=js"
export * from "./InquiryTable.vue?vue&type=script&lang=js"
import style0 from "./InquiryTable.vue?vue&type=style&index=0&id=153ceea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153ceea4",
  null
  
)

export default component.exports